import React from "react";

const Button = ({
  children,
  variant = "primary",
  size = "md",
  fullWidth = false,
  disabled = false,
  onClick,
  type = "button",
  className = "",
}) => {
  const baseStyles =
    "font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";

  const variantStyles = {
    primary:
      "bg-primary-900 text-white hover:bg-primary-800 focus:ring-primary-500 disabled:bg-primary-300",
    secondary:
      "bg-secondary-500 text-primary-900 border border-primary-300 hover:bg-secondary-400 focus:ring-secondary-500 disabled:bg-secondary-200",
    outline:
      "bg-transparent text-primary-900 border border-primary-900 hover:bg-primary-50 focus:ring-primary-500 disabled:border-primary-300 disabled:text-primary-300",
    danger:
      "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 disabled:bg-red-300",
    ghost:
      "bg-transparent text-primary-900 hover:bg-primary-50 focus:ring-primary-500 disabled:text-primary-300",
  };

  const sizeStyles = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg",
  };

  const widthStyles = fullWidth ? "w-full" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${className} disabled:cursor-not-allowed`}
    >
      {children}
    </button>
  );
};

export default Button;
